import { render, staticRenderFns } from "./ProfileInfoItem.vue?vue&type=template&id=6c735f0c&scoped=true&"
import script from "./ProfileInfoItem.vue?vue&type=script&lang=js&"
export * from "./ProfileInfoItem.vue?vue&type=script&lang=js&"
import style0 from "./ProfileInfoItem.vue?vue&type=style&index=0&id=6c735f0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c735f0c",
  null
  
)

export default component.exports